import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    padding: 45,
    top: "50%",
    left: "50%",
    width: "100%",
    position: "absolute",
    transform: "translate(-50%, -50%)",
    boxSizing: "border-box",
    alignItems: "center",
    gap: 8,
  },
  btnShop: {
    marginTop: 8,
  },
});
